var _rect, _rect2, _rect3, _polygon, _rect4, _rect5, _rect6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCreate({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 41",
    style: {
      enableBackground: "new 0 0 64 41"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    className: "st0",
    width: 38,
    height: 6
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 11,
    className: "st0",
    width: 38,
    height: 6
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 22,
    className: "st0",
    width: 38,
    height: 6
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "58,27 58,33 64,33 64,35 58,35 58,41 56,41 56,35 50,35 50,33 56,33 56,27 "
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 6,
    height: 6
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    y: 11,
    className: "st0",
    width: 6,
    height: 6
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    y: 22,
    className: "st0",
    width: 6,
    height: 6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCreate);
export default __webpack_public_path__ + "static/media/icon_create.2edf3da15013ee7259ea6de0207dc4e3.svg";
export { ForwardRef as ReactComponent };